interface HaloVideoProps {
  className?: string;
}

// Looping video used as the AI icon. The parent decides the shape (e.g.
// rounded-full + overflow-hidden) and clips the video into that mask.
export function HaloVideo({ className = '' }: HaloVideoProps) {
  return (
    <video
      src="/halo.mp4"
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      aria-hidden="true"
      className={`block w-full h-full object-cover pointer-events-none scale-125 ${className}`}
    />
  );
}
